// src/admin/adminSections.ts
export type AdminSection = {
    path: string;
    label: string;
    role: string;
};

export const ADMIN_SECTIONS: AdminSection[] = [
    { path: "/admin", label: "Админ-панель", role: "ROLE_ADMIN" },

    { path: "/admin/orders", label: "Заказы", role: "ROLE_ADMIN_ORDERS" },
    { path: "/admin/orders/view", label: "Просмотр заказов", role: "ROLE_VIEW_ORDERS" },

    { path: "/admin/discount", label: "Скидки", role: "ROLE_ADMIN_DISCOUNT" },
    { path: "/admin/documents", label: "Документы", role: "ROLE_ADMIN_DOCS" },
    { path: "/admin/news", label: "Новости", role: "ROLE_ADMIN_NEWS" },
    // { path: "/admin/notifications", label: "Уведомления", role: "ROLE_ADMIN_NOTIFICATIONS" },
    { path: "/admin/workers", label: "Сервисные пользователи", role: "ROLE_ADMIN_WORKERS" },
    { path: "/admin/supplies", label: "Поставки", role: "ROLE_ADMIN_SUPPLIES" },
    { path: "/admin/directions", label: "Направления", role: "ROLE_ADMIN_DIRECTIONS" },
];

export function getRoleNames(roles?: { id: number; name: string }[]) {
    return (roles ?? []).map((r) => r.name);
}

export function getVisibleAdminSections(roleNames: string[]) {
    return ADMIN_SECTIONS.filter((s) => roleNames.includes(s.role));
}
